import { Mark } from '@tiptap/core'

const TiptapFontFamily = Mark.create({
  name: 'fontfamily',

  addOptions () {
    return {
      fontFamily: ['']
    }
  },

  addAttributes () {
    return {
      fontFamily: {
        default: '',
        parseHTML: element => {
          return element.style.fontFamily || element.getAttribute('data-font-family') || ''
        },
        renderHTML: attrs => {
          if (!attrs.fontFamily) {
            return {}
          }

          return {
            style: `font-family:${attrs.fontFamily}`
          }
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'spanec'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['spanec', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      fontfamily: attrs => ({ commands }) => {
        const value = attrs && attrs.fontFamily ? attrs.fontFamily : ''

        if (!value) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, { fontFamily: value })
      },
      resetFont: () => ({ commands }) => {
        commands.unsetMark('fontfamily')
        commands.unsetMark('fontweight')
      }
    }
  }
})

export default TiptapFontFamily
